export default "__VITE_ASSET__LGBjBZvu__"